import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  AutomationsWorkflowsService,
  type TCWorkflowCreateBodyParams,
  type TCWorkflowCreateResponse,
} from 'src/api/generated';

interface UseCreateWorkflowParams {
  body: TCWorkflowCreateBodyParams;
}

export const useCreateWorkflowMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<TCWorkflowCreateResponse, Error, UseCreateWorkflowParams>({
    mutationFn: async ({ body }) => {
      return AutomationsWorkflowsService.createWorkflow(body);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['automations/workflows'],
      });
    },
  });
};
